var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"notfound"},[_c('div',{staticClass:"bg-stars"},[_c('BackgroundStars'),_c('div',{staticClass:"notfound-content text-center mt-8"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("The page you're looking for is missing.")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }